import { useRouter } from 'next/router'
import qs from 'query-string'
import { useEffect, useState } from 'react'

import FilterCategories from '@/ts/enums/global/FilterCategories'

function useFilters() {
  const [filters, setFilters] = useState<State>({})
  const router = useRouter()
  const string = router.query.filters as string

  useEffect(() => {
    if (process.browser && router.isReady) {
      const base64 = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$/

      if (base64.test(string)) {
        const decodedQuery = window.atob(string)
        const parsedQuery = qs.parse(decodedQuery, {
          arrayFormat: 'separator',
          arrayFormatSeparator: '|',
          parseNumbers: true,
        })

        const a = Object.entries(parsedQuery).reduce(
          (a: Record<string, any>, [key, ids]) => {
            if (ids) a[key] = [ids].flat().filter((id) => id)
            return a
          },
          {}
        )

        return setFilters(a)
      }

      setFilters({})
    }
  }, [router.isReady, router.query.filters])

  return filters
}

type State = Record<FilterCategories | string, unknown[]>

export default useFilters
